// vendors
import { useState, useEffect, useRef } from "react";
import Typography from "@mui/material/Typography";

// components
import { Editor } from "../../../../../Components/FlowBuilder/ui-components";

// utils
import {
  getHTMLContent,
  getInitialEditorText,
  getPlainTextData,
} from "../../../Utils/editor";
import { EditorState } from "draft-js";

type InteractiveMessageBodyProps = {
  maxTextLimit: number;
  text: string;
  onChange: (text: string) => void;
  error: any;
  disableApi?:boolean;
  disableBullets?:boolean;
  disableUnderline?: boolean;
  callingFromLanguage?: boolean;
};

const InteractiveMessageBody = ({
  text,
  maxTextLimit = 0,
  onChange,
  error,
  disableApi = false,
  disableBullets = false,
  disableUnderline = false,
  callingFromLanguage = false
}: InteractiveMessageBodyProps) => {
  const [editorState, setEditorState] = useState<any>(
    getInitialEditorText(text || ""),
  );
  const isUserTyping = useRef(false);
  
  const [characterLimitError, setCharacterLimitError] = useState<string | null>(null);

  // Only sync when text prop changes and user is not actively typing
  useEffect(() => {
    if (text !== undefined && !isUserTyping.current && callingFromLanguage) {
      const cleanedText = text.replace(/\n+$/, '').replace(/\s+$/, '');
      const currentContent = getHTMLContent(editorState);
      if (currentContent !== cleanedText) {
      const newEditorState = getInitialEditorText(cleanedText);
        setEditorState(newEditorState);
      }
    }
  }, [text]);
  const onEditorStateChange = (editorStateValue: any) => {
    isUserTyping.current = true;
    const charLength = getPlainTextData(editorStateValue)?.length || 0;
    if (charLength > maxTextLimit) {
      return;
    }

    setEditorState(editorStateValue);
    let htmlText = getHTMLContent(editorStateValue);
    onChange(htmlText.replace(/\*(.*?)\*/g, "<strong>$1</strong>"));
  };

  const handleError = (errorMessage: string | null) => {
    setCharacterLimitError(errorMessage);
  };

  return (
    <>
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        hideFocusOnLoad={true}
        whatsappEditorOptions={true}
        error={error}
        maxTextLimit={maxTextLimit}
        onError={handleError}
        disableApi={disableApi}
        disableBullets={disableBullets}
        disableUnderline={disableUnderline}
      />

      {characterLimitError && (
        <Typography color="error" variant="caption">
          {characterLimitError}
        </Typography>
      )}
      <Typography style={{color:error ? "red":""}} align="right" variant="body2">
        {getPlainTextData(editorState)?.length}/{maxTextLimit}
      </Typography>
    </>
  );
};
export default InteractiveMessageBody;
